import RequestedWithdrawalCard from './RequestedWithdrawalCard';

export default RequestedWithdrawalCard;
